import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { SMS_TYP_PZN } from './constants';

export type SmsTextType = DropdownItem & {
	PovinnyText: string,
	SmsTypPzn: SMS_TYP_PZN,
	VolitelnyText: string,
};

export class SmsEdit {
	SmsTypPzn: number | null = null;
	TemplatePzn: number | null = null;
	PovinnyText: string | null = null;
	VolitelnyText: string | null = null;
	RecepientList: string[] | null = [];
	Recepient: string | null = null;
	ZakazkaId: number | null = null;
	ZakaznikId: number | null = null;
	DokladId: number | null = null;
	DokladnvId: number | null = null;
	DokladovId: number | null = null;
	OzakazkobjId: number | null = null;
	PlanpujcpaId: number | null = null;
	VstupPracId: number | null = null;
	OzakazkaId: number | null = null;
	ZakaznikkonId: number | null = null;
	PseudodokladId: number | null = null;
	ValidationRules: Record<string, any> | null = {};
	DropDownList :Record<string, any> | null = { SmsTypPzn: [], SmsText: [] as SmsTextType[] };
	MsgLogSmsTemplateList: Record<string, any>[] | null = [];
	MsgLogSmsTemplateVolnaSmsList: Record<string, any>[] | null = [];
	constructor(public checked: boolean | null = true) {}
}

export class EmailEdit {
	emailTypPzn: number | null = null;
	TemplatePzn: string | null = null;
	Msg: string | null = null;
	RecepientList: string[] | null = [];
	Recepient: string | null = null;
	Subj: string | null = null;
	ZakaznikId: number | null = null;
	Osloveni: string | null = null;
	Pozdrav: string | null = null;
	ZakazkaId: number | null = null;
	DokladId: number | null = null;
	DokladnvId: number | null = null;
	DokladovId: number | null = null;
	OzakazkobjId: number | null = null;
	PlanpujcpaId: number | null = null;
	VstupPracId: number | null = null;
	OzakazkaId: number | null = null;
	ZakaznikkonId: number | null = null;
	PseudodokladId: number | null = null;
	MsgLogEmailTemplateList: Record<string, any>[] | null = [];
	ValidationRules: Record<string, any> | null = {};
	DropDownList: Record<string, any> | null = { EmailTypPzn: [] };
	PreparedAttachments: Record<string, any> | null = [];

	constructor(public checked: boolean | null = true) {}
}
